// extracted by mini-css-extract-plugin
export default {"container":"OrdersApprovals_container__sv3O7"};